var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.componentKey === "carousel"
        ? _c("Carousel", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "carouselForm"
        ? _c("CarouselForm", {
            attrs: { propsData: _vm.propsData },
            on: { updateForm: _vm.updateForm },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "search"
        ? _c("Search", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "searchForm"
        ? _c("SearchForm", {
            attrs: { propsData: _vm.propsData },
            on: { updateForm: _vm.updateForm },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "navList"
        ? _c("NavList", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "navListForm"
        ? _c("NavListForm", {
            attrs: { propsData: _vm.propsData },
            on: { updateForm: _vm.updateForm },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "arrangeImages"
        ? _c("ArrangeImages", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "arrangeImagesForm"
        ? _c("ArrangeImagesForm", {
            attrs: { propsData: _vm.propsData },
            on: { updateForm: _vm.updateForm },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "goods"
        ? _c("Marketgoods", {
            attrs: { isAlone: true, propsData: _vm.propsData },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "goodsForm"
        ? _c("MarketgoodsForm", {
            attrs: { isAlone: true, propsData: _vm.propsData },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "hotspot"
        ? _c("Hotspot", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "hotspotForm"
        ? _c("HotspotForm", {
            attrs: { propsData: _vm.propsData },
            on: { updateForm: _vm.updateForm },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "marketgoods"
        ? _c("Marketgoods", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "marketgoodsForm"
        ? _c("MarketgoodsForm", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "pintuan"
        ? _c("PintuanGoods", { attrs: { propsData: _vm.propsData } })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentKey === "pintuanForm"
        ? _c("PintuanGoodsForm", {
            attrs: { propsData: _vm.propsData },
            on: { updateForm: _vm.updateForm },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }